export default "__VITE_ASSET__2baa5af2__"